import { CustomButton } from '../../../components/buttons/Buttons';
import './ScaleConverter.css';
import { useState } from 'react';
import { convertScalesToIndividuals } from '../converterModel';

interface ScaleConverterProps {
    title1: string;
    title2: string;
    description: string;
    firstColumn: string;
    secondColumn: string;
    thirdColumn: string;
    firstRow: string;
    secondRow: string;
    thirdRow: string;
}

export const ScaleConverter: React.FC<ScaleConverterProps> = (props) => {

    const [isCalculated, setIsCalculated] = useState(false)
    const [isKg, setIsKg] = useState(false);
    const [inputValue, setInputValue] = useState<number>(0);


    //Timer for animation
    const [bb, setBB] = useState<string[]>(["?", "?", "?"]);
    const [sp, setSP] = useState<string[]>(["?", "?", "?"]);
    const [wb, setWB] = useState<string[]>(["?", "?", "?"]);

    const sizeClass = (value: string) =>
        `ScaleConverter-Size-${value.length <= 7 ? 'm' : value.length <= 9 ? 'l' : 'xl'}`;

    const allZero = [bb, sp, wb].every(values => values.every(v => v === "0"));

    function numberWithCommas(x: number) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    function changeInputType(type: string){
        if (type === "g"){
            if (isKg){
                setInputValue(inputValue*1000);
                setIsKg(false);
            }
        } else if (type === "kg"){ 
            if (!isKg){
                setInputValue(inputValue/1000);
                setIsKg(true);
            }
        }
    }

    function clear(){
        setInputValue(0);
        setIsCalculated(false);
        setBB(["?", "?", "?"]);
        setSP(["?", "?", "?"]);
        setWB(["?", "?", "?"]);
    }

    function calculate(input: number){
        if (isKg){
            input = input * 1000;
        }
        if (!Number.isFinite(input) || input < 0){
            return;
        }
        const result = convertScalesToIndividuals(input);
        const format = (r: { lower: number, estimate: number, upper: number }) =>
            [numberWithCommas(r.lower), numberWithCommas(r.estimate), numberWithCommas(r.upper)];
        setBB(format(result.blackBellied));
        setSP(format(result.smutsia));
        setWB(format(result.whiteBellied));
        setIsCalculated(true)
    }

    return(
        <>
            <div className="ScaleConverter-Container">
                <h1>{props.title1}</h1>
                <div className="ScaleConverter-Calculator-Desktop">
                    <h5>Enter the mass of seized pangolin scales:</h5>
                    <div className='ScaleConverter-Calculator-Desktop-Inputs'>
                        <input 
                            value={inputValue.toString()}
                            id="inputValue"
                            className="ScaleConverter-Calculator-Desktop-ValueInput" 
                            type={"number"}
                            pattern="[0-9.]+"
                            onChange={(e) => { 
                                setInputValue(parseFloat(e.target.value))}}>
                        </input>
                        <div className='ScaleConverter-Calculator-Desktop-ValueInput-Measure'>
                            <button 
                                className={ isKg ? 'ScaleConverter-Calculator-Desktop-Inputs-kgButton' : 'ScaleConverter-Calculator-Desktop-Inputs-gButton' }
                                onClick={() => changeInputType("kg")}
                            >
                            kg
                            </button>
                            <button 
                                className={ isKg ? 'ScaleConverter-Calculator-Desktop-Inputs-gButton' : 'ScaleConverter-Calculator-Desktop-Inputs-kgButton' }
                                onClick={() => changeInputType("g")}
                            >g
                            </button>
                        </div>
                    </div>
                    <div className='ScaleConverter-Calculator-Desktop-Buttons'>
                        <div onClick={() => calculate(inputValue)}>
                            <CustomButton 
                                type={''} 
                                styleType={'filled-inversed'}
                                text={'Calculate'}>
                            </CustomButton>
                        </div>
                        <div onClick={clear}>
                            <CustomButton 
                                type={''} 
                                styleType={'unfilled-inversed'}
                                text={'Clear'}>
                            </CustomButton>
                        </div>
                    </div>
                </div>
            </div>
            {isCalculated ?
                <div className="ScaleConverter-Container-Second">
                    <div className={isCalculated ? 'mountedStyle' : 'unmountedStyle'}>
                        <h1>{props.title2}</h1>
                        {props.description !== "" &&
                            <p>{props.description}</p>
                        }
                        {allZero &&
                            <p className="ScaleConverter-ZeroHint">
                                This mass is less than one animal's worth of scales for every species. Try a larger mass, or switch the unit to kg if you meant kilograms.
                            </p>
                        }
                        <div className="ScaleConverter-TableWrap">
                            <table className="ScaleConverter-Results">
                                <thead>
                                    <tr>
                                        <td className="ScaleConverter-Results-Corner"></td>
                                        <th scope="col">{props.firstColumn}</th>
                                        <th scope="col">{props.secondColumn}</th>
                                        <th scope="col">{props.thirdColumn}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[
                                        { name: props.firstRow, values: bb },
                                        { name: props.secondRow, values: sp },
                                        { name: props.thirdRow, values: wb },
                                    ].map(({ name, values }) => (
                                        <tr key={name}>
                                            <th scope="row">{name}</th>
                                            <td className={`ScaleConverter-Results-Estimate ${sizeClass(values[1])}`}>{values[1]}</td>
                                            <td className={sizeClass(values[0])}>{values[0]}</td>
                                            <td className={sizeClass(values[2])}>{values[2]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div> 
                </div> : <></>
                }    
            
            <div>
                
            </div>
        </>
    )
}